module.exports = __webpack_public_path__ + "static/media/card5_6.7a671f3b.png";